import { Injectable, signal } from '@angular/core';

/** Stessa chiave di prima: chi aveva la sidebar compressa se la ritrova. */
export const CHIAVE_SIDEBAR_COMPRESSA = 'sidebar-collapsed';

/**
 * Stato del menu laterale.
 *
 * Sono due cose diverse e vanno tenute separate: su schermo largo la sidebar
 * si *comprime* a sole icone, e la scelta si ricorda; su schermo stretto e' un
 * pannello che si *apre* sopra il contenuto e parte sempre chiuso.
 *
 * Prima lo stato viveva in un getter/setter su `localStorage` dentro il
 * componente — quindi la UI non reagiva al cambiamento — e `ngOnInit` lo
 * riscriveva a ogni avvio con `window.innerWidth < 850`, cancellando la
 * preferenza dell'utente.
 */
@Injectable({
  providedIn: 'root',
})
export class NavigazioneService {
  readonly compressa = signal<boolean>(localStorage.getItem(CHIAVE_SIDEBAR_COMPRESSA) === 'true');
  readonly apertaSuMobile = signal<boolean>(false);

  alternaCompressione(): void {
    this.compressa.update((valore) => {
      const nuovo = !valore;
      localStorage.setItem(CHIAVE_SIDEBAR_COMPRESSA, String(nuovo));
      return nuovo;
    });
  }

  alternaMobile(): void {
    this.apertaSuMobile.update((aperta) => !aperta);
  }

  chiudiMobile(): void {
    this.apertaSuMobile.set(false);
  }

  /** Dopo una navigazione il pannello si richiude, la compressione resta. */
  haNavigato(): void {
    this.chiudiMobile();
  }
}
